import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import { getCategory } from "@/content/categories";
import { isLessonComplete } from "@/lib/progress";
import Icon from "@/components/shared/Icon";

export default function LessonCard({ lesson }) {
  const { t, lp, code } = useLang();
  const cat = getCategory(lesson.category);
  const done = isLessonComplete(lesson.slug);

  return (
    <Link
      to={lp(`/learn/${lesson.slug}`)}
      data-testid={`lesson-card-${lesson.slug}`}
      className="group relative flex flex-col overflow-hidden rounded-3xl border-2 border-[#147DEB]/10 bg-white p-6 transition-all duration-300 hover:-translate-y-1 hover:border-[#147DEB]/30 hover:shadow-xl"
    >
      <div className="flex items-center justify-between">
        <span
          className="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold"
          style={{ backgroundColor: `${cat.color}1a`, color: cat.color }}
        >
          <Icon name={cat.icon} className="h-3.5 w-3.5" />
          {cat.name[code]}
        </span>
        {done && (
          <span className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-bold text-emerald-700">
            <Icon name="CheckCircle2" className="h-3.5 w-3.5" />
            {t("common.completed")}
          </span>
        )}
      </div>

      <h3 className="font-display mt-4 text-xl font-bold text-[#082B66]">{lesson.title[code]}</h3>
      <p className="mt-2 flex-1 text-sm leading-relaxed text-[#475569]">{lesson.desc[code]}</p>

      <div className="mt-5 flex items-center gap-4 text-xs font-semibold text-[#64748B]">
        <span className="inline-flex items-center gap-1">
          <Icon name="Baby" className="h-4 w-4 text-[#FF91B8]" /> {t("common.age")} {lesson.age}
        </span>
        <span className="inline-flex items-center gap-1">
          <Icon name="Clock" className="h-4 w-4 text-[#147DEB]" /> {lesson.minutes} {t("common.min")}
        </span>
      </div>

      <span className="mt-5 inline-flex items-center justify-center gap-1.5 rounded-2xl bg-[#E8F5FF] px-4 py-2.5 text-sm font-bold text-[#147DEB] transition-colors group-hover:bg-[#147DEB] group-hover:text-white">
        {done ? t("common.continue") : t("common.startLesson")}
        <Icon name="ArrowRight" className="h-4 w-4" />
      </span>
    </Link>
  );
}
